/**
 * @file JS - classes/Page/ElementTexte.js
 * @author : Adam Lemire
 * @since 2021/10/05
 * @version 1.0
 * @summary Dernières modifications : 2021/10/25
 */

import { hideContextMenus } from '../../../helpers/GlobalFunctions';
import { Evenements } from '../../../events/Evenements.js';
import { dictionary } from '../../../helpers/languageDictionary.js';

require('jquery-ui/ui/core');
require('jquery-ui/ui/widgets/accordion');
require('jquery-ui/ui/widgets/spinner');
require('jquery-ui/ui/widgets/resizable');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui/ui/effects/effect-size');
require('jquery-ui/ui/effects/effect-slide');
require('jquery-ui/themes/base/base.css');
require('jquery-ui/themes/base/draggable.css');
require('jquery-ui/themes/base/theme.css');
require('jquery-ui/themes/base/spinner.css');
require('jquery-ui/themes/base/button.css');
require('jquery-ui/themes/base/resizable.css');
require('jquery-ui/themes/base/slider.css');
require('jquery-ui/themes/base/accordion.css');

export default class ElementTexte {
  /**
   * @example new ElementTexte( { id: pageId, title: pageName, targetMap: mapSectionId } )
   * @param { object } options - Options du constructeur
   * @param { number } options.idLayout - Id objet layout
   * @param { string } options.idElementTexte - Id à attribuer à cet ElementTexte
   * @param { object } options.objetJSON - Seulement lorsque créé par l'ouverture d'un projet existant
   */
  constructor ({ idLayout, idElementTexte, objetJSON = false }) {
    if (!objetJSON) {
      this._id = idElementTexte;
      this._idDiv = 'layout-' + idLayout + '__element-texte-' + idElementTexte;
      this._idDivLayout = 'layout-page-' + idLayout;
      this._taillePolice = 14;
      this._couleurTexte = '#000000';
      this._transparenceArrierePlan = 0;
      this._largeur = 200;
      this._positionX = 0;
      this._positionY = 0;
      this._texte = window.localStorage.getItem('lang') === 'en' ? dictionary.layoutPage.editeur.texte.titre.en + idElementTexte : dictionary.layoutPage.editeur.texte.titre.fr + idElementTexte;
    } else {
      this._creerDepuisJSON(objetJSON);
    }
  }

  get id () { return this._id; }

  get idDiv () { return this._idDiv; }

  creerDiv () {
    const _this = this;
    const conteneur = '#' + this._idDivLayout + ' .export-layout__preview-map';
    const div = document.createElement('div');
    const divIdJQ = '#' + this._idDiv;
    const paragraphe = '<p style="line-height: 1; display: inline-block; vertical-align: middle; margin: 10px; text-align: center; width: 100%">' + this._texte + '</p>';

    div.id = this._idDiv;
    div.className = 'layout__element layout__element-texte';
    div.style.position = 'absolute';
    div.style.left = this._positionX + 'px';
    div.style.top = this._positionY + 'px';
    div.style.width = this._largeur + 'px';
    div.style.height = 'auto';
    div.style.background = 'rgba(255, 255, 255, ' + (1 - this._transparenceArrierePlan) + ')';
    div.style.color = this._couleurTexte;
    div.style.fontSize = this._taillePolice + 'px';
    div.style.textAlign = 'center';
    div.style.display = 'flex';
    div.style.alignItems = 'center';

    $(conteneur).append(div);
    $(divIdJQ).append(paragraphe);

    $(divIdJQ).draggable({
      cursor: 'move',
      stop: function (event, ui) {
        _this._positionX = ui.position.left;
        _this._positionY = ui.position.top;
      }
    });

    $(divIdJQ).resizable({
      handles: 'e, w',
      stop: function (event, ui) {
        _this._largeur = ui.size.width;
      }
    });
  }

  creerDivEditeur () {
    const divEditeurId = 'editeur-element-texte-' + this._id;
    const divEditeur = '<h3 id="bouton-editeur-element-' + this._id + '" class="bouton-editeur-element"><span data-text="layoutPage.editeur.texte.titre"></span> ' + this._id + '</h3><table id="' + divEditeurId + '" class="editeur-element editeur-element-texte"></table>';

    $('.conteneur__editeur-element').append(divEditeur);
    Evenements.texteAjoute.notify();

    this._creerDivEditeurTexte();
    this._creerDivEditeurTaillePolice();
    this._creerDivEditeurTransparence();
    $('.conteneur__editeur-element').accordion('refresh');
    $('.conteneur__editeur-element').accordion('option', 'active', -1);
    // this._ecouterAfficherMenuContextuel();
  }

  _ecouterAfficherMenuContextuel () {
    const boutonEditeurElementIdJq = '#bouton-editeur-element-' + this._id;
    const menuContextuelIdJQ = '#context-menu-' + this._idDiv;
    let menu;

    if (!document.getElementById('context-menu-' + this._idDiv)) {
      menu = document.createElement('div');

      menu.id = 'context-menu-' + this._idDiv;
      menu.className = 'context-menu context-menu-editeur-element hidden';

      $('.inner-windows').append(menu);

      const optionSupprimer = '<ul class="context-menu__options"><li class="context-menu__option context-menu__option-editeur-element-' + this._id + '" data-text="contextMenu.remove"></li></ul>';

      $(menuContextuelIdJQ).append(optionSupprimer);
      Evenements.texteAjoute.notify();
      this._ecouterEnleverEditeurElement();
    } else {
      menu = document.getElementById('context-menu-' + this._idDiv);
    }

    const setPosition = ({
      top,
      left
    }) => {
      hideContextMenus();
      menu.style.left = `${left}px`;
      menu.style.top = `${top}px`;
      $(menuContextuelIdJQ).removeClass('hidden');
    };

    $(boutonEditeurElementIdJq).on('contextmenu', e => {
      e.preventDefault();
      const origin = {
        left: e.pageX,
        top: e.pageY
      };
      setPosition(origin);
      return false;
    });
  }

  _ecouterEnleverEditeurElement () {
    const optionEnleverClasseJQ = '.context-menu__option-editeur-element-' + this._id;
    const divElementIdJQ = '#' + this._idDiv;
    const enteteEditeurIdJQ = '#bouton-editeur-element-' + this._id;
    const divEditeurIdJQ = '#editeur-element-texte-' + this._id;
    const menuContextuelIdJQ = '#context-menu-' + this._idDiv;

    $(optionEnleverClasseJQ).on('click tap', function () {
      $(divElementIdJQ).remove();
      $(enteteEditeurIdJQ).remove();
      $(divEditeurIdJQ).remove();
      $(menuContextuelIdJQ).remove();
    });
  }

  _creerDivEditeurTexte () {
    const _this = this;
    const divEditeurId = 'editeur-element-texte-' + this._id;
    const divEditeurIdJQ = '#' + divEditeurId;
    const inputJQ = '#' + divEditeurId + '__texte';
    const texteEditeur = '<tr><td><label for="' + divEditeurId + '__texte" data-text="layoutPage.editeur.texte.texte"></label></td>' +
      '<td><input type="text" id="' + divEditeurId + '__texte" class="editeur-element-texte__texte" name="' + divEditeurId + '__texte" data-placeholder="placeholder.text" value="' + this._texte + '"></td></tr>';

    $(divEditeurIdJQ).append(texteEditeur);
    $(inputJQ).on('input', function (e) {
      const paragrapheJQ = '#' + _this._idDiv + ' p';
      _this._texte = e.target.value;
      $(paragrapheJQ).text(e.target.value);
    });
  }

  _creerDivEditeurTaillePolice () {
    const _this = this;
    const divEditeurId = 'editeur-element-texte-' + this._id;
    const divEditeurIdJQ = '#' + divEditeurId;
    const inputJQ = '#' + divEditeurId + '__taille';
    const tailleEditeur = '<tr><td><label for="' + divEditeurId + '__taille" data-text="layoutPage.editeur.texte.taille"></label></td>' +
      '<td><input id="' + divEditeurId + '__taille" class="editeur-element-texte__taille" name="' + divEditeurId + '__taille" value="' + this._taillePolice + '"></td></tr>';

    $(divEditeurIdJQ).append(tailleEditeur);
    $(inputJQ).spinner({
      min: 0,
      max: 50,
      stop: function (event, ui) {
        const paragrapheJQ = '#' + _this._idDiv;
        _this._taillePolice = event.target.value;
        $(paragrapheJQ).css('font-size', event.target.value + 'px');
      }
    });
  }

  _creerDivEditeurTransparence () {
    const _this = this;
    const divEditeurId = 'editeur-element-texte-' + this._id;
    const divEditeurIdJQ = '#' + divEditeurId;
    const inputJQ = '#' + divEditeurId + '__transparence';
    const tailleEditeur = '<tr><td><label for="' + divEditeurId + '__transparence" data-text="layoutPage.editeur.texte.transparence"></label></td></tr>' +
      '<tr><td colspan="2"><div id="' + divEditeurId + '__transparence" name="' + divEditeurId + '__transparence" style="margin: 10px;"></div></td></tr>';

    $(divEditeurIdJQ).append(tailleEditeur);
    $(inputJQ).slider({
      value: _this._transparenceArrierePlan,
      min: 0,
      max: 1,
      step: 0.01,
      slide: function (event, ui) {
        const paragrapheJQ = '#' + _this._idDiv;
        _this._transparenceArrierePlan = ui.value;
        $(paragrapheJQ).css('background', 'rgba(255, 255, 255, ' + (1 - ui.value) + ')');
      }
    });
  }

  /*
   * EXPORTATION ET CREATION DEPUIS JSON
   */

  toJSON () {
    const objetJSON = {
      id: this._id,
      idDiv: this._idDiv,
      idDivLayout: this._idDivLayout,
      taillePolice: this._taillePolice,
      couleurTexte: this._couleurTexte,
      transparenceArrierePlan: this._transparenceArrierePlan,
      largeur: this._largeur,
      positionX: this._positionX,
      positionY: this._positionY,
      texte: this._texte
    };

    return objetJSON;
  }

  _creerDepuisJSON (objetJSON) {
    this._id = objetJSON.id;
    this._idDiv = objetJSON.idDiv;
    this._idDivLayout = objetJSON.idDivLayout;
    this._taillePolice = objetJSON.taillePolice;
    this._couleurTexte = objetJSON.couleurTexte;
    this._transparenceArrierePlan = objetJSON.transparenceArrierePlan;
    this._largeur = objetJSON.largeur;
    this._positionX = objetJSON.positionX;
    this._positionY = objetJSON.positionY;
    this._texte = objetJSON.texte;
  }
}
